import { useState, useEffect, forwardRef } from 'react'
import EditableInput from './EditableInput'
import s from './styles.scss'
import cn from 'classnames'
import TextareaAutosize from 'react-textarea-autosize'
import { Button } from 'reactstrap'
import { NumericFormat } from 'react-number-format'
import { getCurrency } from 'utils/authService'

const initialInvoice = {
  productLineDescription: 'Item Description',
  productLineQuantityAmount: 'Amount',
  productLines: [
    {
      description: '',
      amount: ''
    }
  ],
  subTotalLabel: 'Subtotal',
  overheadLabel: 'Overhead & Profit',
  insuranceLabel: 'Insurance',
  totalLabel: 'TOTAL',
  currency: getCurrency().symbol
}

const PricingTableSimple_V2 = forwardRef((props, ref) => {
  const { isPdf, content, actions, icons, isStandAloneComponent } = props
  const [invoice, setInvoice] = useState(initialInvoice)
  const [subTotal, setSubTotal] = useState()
  const [overheadTax, setOverheadTax] = useState(0)
  const [insuranceTax, setInsuranceTax] = useState(0)

  useEffect(() => {
    if (content) {
      setInvoice(JSON.parse(content))
    }
  }, [content])

  const handleChange = (name, value) => {
    if (name !== 'productLines') {
      const newInvoice = { ...invoice }
      newInvoice[name] = value

      setInvoice(newInvoice)
    }
  }

  const handleProductLineChange = (index, name, value) => {
    const productLines = invoice.productLines.map((productLine, i) => {
      if (i === index) {
        const newProductLine = { ...productLine }

        if (name === 'description') {
          newProductLine[name] = value
        } else {
          if (
            value[value.length - 1] === '.' ||
            (value[value.length - 1] === '0' && value.includes('.'))
          ) {
            newProductLine[name] = value
          } else {
            const n = parseFloat(value)

            newProductLine[name] = (n ? n : 0).toString()
          }
        }

        return newProductLine
      }

      return { ...productLine }
    })

    setInvoice({ ...invoice, productLines })
  }

  const handleRemove = i => {
    const productLines = invoice.productLines.filter((productLine, index) => index !== i)

    setInvoice({ ...invoice, productLines })
  }

  const handleAdd = () => {
    const productLines = [
      ...invoice.productLines,
      {
        description: ''
      }
    ]

    setInvoice({ ...invoice, productLines })
  }

  useEffect(() => {
    let subTotal = 0

    invoice.productLines.forEach(productLine => {
      subTotal = subTotal + parseFloat(productLine.amount)
    })

    setSubTotal(subTotal)
  }, [invoice.productLines])

  return (
    <>
      {icons}
      <div
        ref={ref}
        className={s.invoiceWrapper}
        style={{
          position: 'relative',
          background: '#fff',
          fontFamily: 'Arial, sans-serif',
          fontSize: '11pt',
          ...(!isPdf ? { padding: '0 20px 0 0' } : {})
        }}
      >
        <div
          style={{
            marginTop: '30px',
            backgroundColor: '#666',
            display: 'flex'
          }}
        >
          <div
            style={{
              width: '80%',
              padding: '4px 8px'
            }}
          >
            <EditableInput
              style={{
                color: '#fff',
                fontWeight: '600'
              }}
              className={cn(s.input, s.white, s.bold)}
              value={invoice.productLineDescription}
              onChange={value => handleChange('productLineDescription', value)}
              isPdf={isPdf}
            />
          </div>
          <div
            style={{
              width: '20%',
              padding: '4px 8px',
              textAlign: 'right'
            }}
          >
            <EditableInput
              style={{
                color: '#fff',
                fontWeight: '600',
                textAlign: 'right'
              }}
              className={cn(s.input, s.white, s.bold, s.right)}
              value={invoice.productLineQuantityAmount}
              onChange={value => handleChange('productLineQuantityAmount', value)}
              isPdf={isPdf}
            />
          </div>
        </div>

        {invoice.productLines.map((productLine, i) => {
          return (
            <div
              key={i}
              className={s.row}
              style={{
                display: 'flex',
                minHeight: '38px',
                justifyContent: 'space-between',
                position: 'relative',
                borderBottom: '1px solid #e3e3e3'
              }}
            >
              <div
                style={{
                  width: '80%',
                  padding: '4px 8px',
                  paddingBottom: '10px'
                }}
              >
                {isPdf ? (
                  productLine.description ? (
                    <span
                      style={{
                        display: 'inline-block',
                        width: '98%',
                        padding: '4px 12px 4px 0',
                        marginBottom: '1px',
                        border: '1px dotted transparent',
                        transition: 'background 0.1s ease-in-out, border-color 0.2s ease-in-out',
                        color: '#222'
                      }}
                    >
                      {productLine.description}
                    </span>
                  ) : (
                    ''
                  )
                ) : (
                  <TextareaAutosize
                    className={cn(s.input, s.dark)}
                    minRows={1}
                    placeholder="Enter item name/description"
                    value={productLine.description || ''}
                    onChange={({ target }) =>
                      handleProductLineChange(i, 'description', target.value)
                    }
                  />
                )}
              </div>
              <div
                style={{
                  width: '20%',
                  padding: '4px 8px',
                  paddingBottom: '10px',
                  textAlign: 'right'
                }}
              >
                <NumericFormat
                  style={{
                    display: 'inline-block',
                    width: '98%',
                    padding: '4px 12px 4px 0',
                    marginBottom: '1px',
                    border: '1px dotted transparent',
                    transition: 'background 0.1s ease-in-out, border-color 0.2s ease-in-out',
                    textAlign: 'right',
                    color: '#222'
                  }}
                  className={isPdf ? '' : cn(s.input, s.dark, s.right)}
                  thousandSeparator
                  decimalScale={2}
                  value={productLine.amount}
                  onChange={formattedValue => {
                    const stripValue = formattedValue.target.value.replace(/[^\d.-]/g, '')
                    handleProductLineChange(i, 'amount', stripValue)
                  }}
                  prefix={getCurrency().symbol}
                  displayType={isPdf ? 'text' : 'input'}
                />
              </div>
              {!isPdf && (
                <button
                  className={cn(s.link, s.row__remove)}
                  aria-label="Remove Row"
                  title="Remove Row"
                  onClick={() => handleRemove(i)}
                >
                  <span className={cn(s.icon, s['icon-remove'], s['bg-red'])}></span>
                </button>
              )}
            </div>
          )
        })}

        <div
          style={{
            display: 'flex'
          }}
        >
          <div
            style={{
              width: '50%',
              marginTop: '10px'
            }}
          >
            {!isPdf && (
              <button className={s.link} onClick={handleAdd}>
                <span className={cn(s.icon, s['icon-add'], s['bg-green'], s['mr-10'])}></span>
                Add Line Item
              </button>
            )}
          </div>
          <div
            style={{
              width: '50%',
              marginTop: '20px'
            }}
          >
            <div
              style={{
                display: 'flex'
              }}
            >
              <div
                style={{
                  width: '50%',
                  padding: '5px'
                }}
              >
                <EditableInput
                  className={s.input}
                  value={invoice.subTotalLabel}
                  onChange={value => handleChange('subTotalLabel', value)}
                  isPdf={isPdf}
                />
              </div>
              <div
                style={{
                  width: '50%',
                  padding: '5px'
                }}
              >
                <NumericFormat
                  style={{
                    display: 'inline-block',
                    width: '98%',
                    padding: '4px 12px 4px 0',
                    marginBottom: '1px',
                    border: '1px dotted transparent',
                    transition: 'background 0.1s ease-in-out, border-color 0.2s ease-in-out',
                    textAlign: 'right',
                    color: '#222',
                    fontWeight: '600'
                  }}
                  thousandSeparator
                  decimalScale={2}
                  value={subTotal?.toFixed(2)}
                  prefix={getCurrency().symbol}
                  displayType="text"
                />
              </div>
            </div>
            <div style={{ display: 'flex' }}>
              <div
                style={{
                  width: '50%',
                  padding: '5px'
                }}
              >
                <EditableInput
                  className={s.input}
                  value={invoice.overheadLabel}
                  onChange={value => handleChange('overheadLabel', value)}
                  isPdf={isPdf}
                />
              </div>
              <div
                style={{
                  width: '50%',
                  padding: '5px'
                }}
              >
                <NumericFormat
                  style={{
                    display: 'inline-block',
                    width: '98%',
                    padding: '4px 12px 4px 0',
                    marginBottom: '1px',
                    border: '1px dotted transparent',
                    transition: 'background 0.1s ease-in-out, border-color 0.2s ease-in-out',
                    textAlign: 'right',
                    color: '#222',
                    fontWeight: '600'
                  }}
                  thousandSeparator
                  decimalScale={2}
                  value={overheadTax?.toFixed(2)}
                  prefix={getCurrency().symbol}
                  onValueChange={formattedValue => {
                    setOverheadTax(+formattedValue.value)
                  }}
                  className={isPdf ? '' : cn(s.input, s.dark, s.right)}
                  displayType={isPdf ? 'text' : 'input'}
                />
              </div>
            </div>
            <div style={{ display: 'flex' }}>
              <div
                style={{
                  width: '50%',
                  padding: '5px'
                }}
              >
                <EditableInput
                  className={s.input}
                  value={invoice.insuranceLabel}
                  onChange={value => handleChange('insuranceLabel', value)}
                  isPdf={isPdf}
                />
              </div>
              <div
                style={{
                  width: '50%',
                  padding: '5px'
                }}
              >
                <NumericFormat
                  style={{
                    display: 'inline-block',
                    width: '98%',
                    padding: '4px 12px 4px 0',
                    marginBottom: '1px',
                    border: '1px dotted transparent',
                    transition: 'background 0.1s ease-in-out, border-color 0.2s ease-in-out',
                    textAlign: 'right',
                    color: '#222',
                    fontWeight: '600'
                  }}
                  thousandSeparator
                  decimalScale={2}
                  value={insuranceTax?.toFixed(2)}
                  prefix={getCurrency().symbol}
                  onValueChange={formattedValue => {
                    setInsuranceTax(+formattedValue.value)
                  }}
                  className={isPdf ? '' : cn(s.input, s.dark, s.right)}
                  displayType={isPdf ? 'text' : 'input'}
                />
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                padding: '5px',
                backgroundColor: '#e3e3e3'
              }}
            >
              <div
                style={{
                  width: '50%',
                  padding: '5px'
                }}
              >
                <EditableInput
                  style={{
                    fontWeight: '600'
                  }}
                  className={cn(s.input, s.bold)}
                  value={invoice.totalLabel}
                  onChange={value => handleChange('totalLabel', value)}
                  isPdf={isPdf}
                />
              </div>
              <div
                style={{
                  width: '50%',
                  padding: '5px',
                  ...(isPdf ? { textAlign: 'right' } : { display: 'flex' })
                }}
              >
                <EditableInput
                  style={{
                    color: '#222',
                    textAlign: 'right',
                    fontWeight: '600',
                    marginLeft: '30px',
                    visibility: 'hidden'
                  }}
                  className={cn(s.input, s.dark, s.bold, s.right, s['ml-30'])}
                  value={invoice.currency}
                  onChange={value => handleChange('currency', value)}
                  isPdf={isPdf}
                  hidden
                />
                <NumericFormat
                  style={{
                    display: 'inline-block',
                    padding: '4px 12px 4px 0',
                    marginBottom: '1px',
                    border: '1px dotted transparent',
                    transition: 'background 0.1s ease-in-out, border-color 0.2s ease-in-out',
                    textAlign: 'right',
                    color: '#222',
                    fontWeight: '600',
                    width: 'auto !important'
                  }}
                  thousandSeparator
                  decimalScale={2}
                  value={
                    typeof subTotal !== 'undefined' &&
                    typeof overheadTax !== 'undefined' &&
                    typeof insuranceTax !== 'undefined'
                      ? (subTotal + overheadTax + insuranceTax).toFixed(2)
                      : 0
                  }
                  prefix={getCurrency().symbol}
                  displayType="text"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {actions && (
        <div className={s.actionBtnsWrapper}>
          {actions.map((button, index) => (
            <Button
              key={index}
              className={cn({
                [button.className]: button.className
              })}
              onClick={() => {
                button.cb(!isStandAloneComponent ? JSON.stringify(invoice) : invoice)
              }}
              disabled={button.enabled ? !button.enabled : false}
            >
              {button.text}
            </Button>
          ))}
        </div>
      )}
    </>
  )
})

export default PricingTableSimple_V2
